import ExtrinsicApi from '../api/extrinsic';

function sortAscending(a, b) {
  return b.score - a.score;
}

function getDefaultState() {
  return {
    features: [],
  };
}

export default {
  namespaced: true,
  state: {
    features: [],
    selectedFeature: null,
    extrinsicData: null,
  },
  getters: {
    selectedFeature(state) {
      return state.selectedFeature;
    },
    allFeatures(state) {
      return state.features;
    },
    audioFeatures(state) {
      return state.features.filter(f => f.type === 'audio');
    },
    topAudioFeatures(state) {
      const sortedList = state.features.filter(f => f.type === 'audio').sort(sortAscending);
      if (sortedList.length > 3) {
        return sortedList.slice(0, 2).concat(sortedList[sortedList.length - 1]);
      }
      return sortedList;
    },
    transcriptFeatures(state) {
      return state.features.filter(f => f.type === 'transcript');
    },
    topTranscriptFeatures(state) {
      const sortedList = state.features.filter(f => f.type === 'transcript').sort(sortAscending);
      if (sortedList.length > 3) {
        return sortedList.slice(0, 2).concat(sortedList[sortedList.length - 1]);
      }
      return sortedList;
    },
    visualFeatures(state) {
      return state.features.filter(f => f.type === 'video');
    },
    topVisualFeatures(state) {
      const sortedList = state.features.filter(f => f.type === 'video').sort(sortAscending);
      if (sortedList.length > 3) {
        return sortedList.slice(0, 2).concat(sortedList[sortedList.length - 1]);
      }
      return sortedList;
    },
    averageAudioScore(state) {
      const audioFeatures = state.features.filter(f => f.type === 'audio');
      let sum = 0;
      audioFeatures.forEach((a) => { sum += a.score; });
      return sum / audioFeatures.length;
    },
    averageTranscriptScore(state) {
      const transcriptFeatures = state.features.filter(f => f.type === 'transcript');
      let sum = 0;
      transcriptFeatures.forEach((a) => { sum += a.score; });
      return sum / transcriptFeatures.length;
    },
    averageVisualScore(state) {
      const visualFeatures = state.features.filter(f => f.type === 'video');
      let sum = 0;
      visualFeatures.forEach((a) => { sum += a.score; });
      return sum / visualFeatures.length;
    },
    overallScore(state, g) {
      const sum = g.averageAudioScore + g.averageTranscriptScore + g.averageVisualScore;
      return Math.round((sum / 3) * 10);
    },
    hasExtrinsic: state => (speechFeature) => {
      return state.extrinsicData && state.extrinsicData[speechFeature];
    },
  },
  actions: {
    resetState(context) {
      context.commit('RESET_STATE');
    },
    getExtrinsicData(context, language) {
      return new Promise(async (resolve) => {
        const badges = await ExtrinsicApi.getInfoBadges(language);

        context.commit('SET_EXTRINSIC_DATA', badges);

        resolve(badges);
      });
    },
    setSelectedFeature(context, featureName) {
      const badge = context.state.extrinsicData[featureName];

      if (badge.train_skill) {
        const videoAnalysis = context.rootState.videoAnalysis;
        const activities = videoAnalysis.personalizedCurriculum.systemRecommendedActivities;
        const score = videoAnalysis.videoScores.find(
          item => item.name === featureName,
        );

        badge.train_skill_activities = activities.filter(
          activity => activity.tags.includes(featureName)
            && score.score >= activity.scoreRange[0]
            && score.score <= activity.scoreRange[1],
        );
      }

      context.commit('SET_SELECTED_FEATURE', badge);
    },
    resetSelectedFeature(context) {
      context.commit('SET_SELECTED_FEATURE', null);
    },
  },
  mutations: {
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState());
    },
    SET_EXTRINSIC_DATA: (state, extrinsicData) => {
      state.extrinsicData = extrinsicData.result.reduce((acc, badge) => {
        acc[badge.key] = badge;
        return acc;
      }, {});
    },
    SET_SELECTED_FEATURE: (state, feature) => {
      state.selectedFeature = feature;
    },
  },
};
